module.exports = __webpack_public_path__ + "img/user-self-report.3473a25e.svg";